import { createFileRoute, redirect } from '@tanstack/react-router';
import { TabbedPageLayout, type RoutedTab } from '@/components/tabbed-page-layout';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/visitor-id',
)({
  // Company-level visitor identification (reverse-IP): the `visitor_company`
  // waterfall (ipapi.is, Ipregistry) + per-provider credentials. Shares the
  // enrichment settings components, scoped to the `visitor_company` slot.
  component: () => (
    <TabbedPageLayout
      title="Company Visitor ID"
      description="Reverse-IP company providers that resolve anonymous visitors to a company."
      tabs={TABS}
    />
  ),
  beforeLoad: async ({ context }) => {
    if (context.platformRole !== 'admin') {
      throw redirect({ to: '/' });
    }
  },
});

const TABS: RoutedTab[] = [
  { to: '/super-admin/visitor-id/configuration', label: 'Configuration' },
  { to: '/super-admin/visitor-id/regions', label: 'Regions' },
  { to: '/super-admin/visitor-id/providers', label: 'Providers' },
];
